import config from 'config'
import React, { useEffect, useState } from 'react';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import "./Reports.css"
import UtilizationStatasticalReport from './UtilizationStatasticalReport/UtilizationStatasticalReport'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StudentWiseLibraryStatistics from './StudentWiseLibraryStatistics/StudentWiseLibraryStatistics';
import ResourceListAsPerAccessionNumber from './ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber';
import DonorList from './DonorList/DonorList';
import UserWiseIssuedReturnResource from './UserWiseIssuedReturnResources/UserWiseIssuedReturnResources';
import ResourceTitleReport from './ResourceTitle/ResourceTitle';
import YearlyPurchaseTitleWithCostReport from './YearlyPurchaseTitleWithCost/YearlyPurchaseTitleWithCost';
import FineReport from './FineReport/FineReport';
import PeriodicalReport from './PeriodicalReport/PeriodicalReport';
import ScannedResourceReport from './ScannedResourcesReport/ScannedResourcesReport';
import IssuedResourceReport from './IssuedResourceReport/IssuedResourceReport';
import MissingYetToScanResourceReport from './MissingYetToScanResourceReport/MissingYetToScanResourceReport';
import DepartmentWiseSummaryReport from './DepartmentWiseSummaryReport/DepartmentWiseSummary';
import CategoryWiseYearlyPurchaseWithCost from './CategoryWiseYearlyPurchaseWithCost/CategoryWiseYearlyPurchaseWithCost';
import FacultyWiseLibraryStatistics from './FacultyWiseLibraryStatistics/FacultyWiseLibraryStatistics';
import ReceivedNonReceivedPeriodicalReport from './ReceivedNonReceivedPeriodicalReport/ReceivedNonReceivedPeriodicalReport';
import LibraryEntryReport from './LibraryEntryReport/LibraryEntryReport';
import UserWiseIssuedReturnResourceByAcdYear from './UserWiseIssuedReturnResourcesByAcadYear/UserWiseIssuedReturnResourcesByAcaYear.js';

export const Reports = (props) => {

  const [reportVisibility, setReportVisibility] = useState(false)
  const [currentReportName, setCurrentReportName] = useState('')
  const [currentReportType, setCurrentReportType] = useState('')
  const [searchFilterText, setSearchFilterText] = useState('')
  const [reportDetails, setReportDetails] = useState({
    // New Report Structure
    1: {
      reportType: 'resourceListAsPerAccessionNumber',
      reportName: 'Resource List As Per Accession Number Report'
    },
    2: {
      reportType: 'issuedResourceReport',
      reportName: 'Issued Resource Report'
    },
    3: {
      reportType: 'returnedResourceReport',
      reportName: 'Returned Resource Report'
    },
    4: {
      reportType: 'pendingResources',
      reportName: 'Pending Resources (Issued but not yet returned.)'
    },
    5: {
      reportType: 'yearlyPurchaseTitleWithCost',
      reportName: 'Yearly Purchase Titles With Cost'
    },
    6: {
      reportType: 'categoryWiseYearlyPurchaseWithCost',
      reportName: 'Category Wise Yearly Purchase With Cost'
    },
    7: {
      reportType: 'listOfMissingResource',
      reportName: 'List of Missing Resources'
    },
    8: {
      reportType: 'listOfDiscardedResources',
      reportName: 'List of Discarded Resources'
    },
    9: {
      reportType: 'listOfDonatedResources',
      reportName: 'List of Donated Resources'
    },
    10: {
      reportType: 'userWiseIssuedReturnResources',
      reportName: 'User-Wise Issued Return Resources'
    },

    11: {
      reportType: 'instructorWithMostIssued',
      reportName: 'Instructor With Most Issued'
    },
    12: {
      reportType: 'learnerWithMostIssued',
      reportName: 'Learner With Most Issued'
    },
    13: {
      reportType: 'currentlyBooksAvailableInLibrary',
      reportName: 'Currently Books Available In Library'
    },
    14: {
      reportType: 'booksCurrentlyNotAvailableInLibrary',
      reportName: 'Books Currently Not Available In Library'
    },
    15: {
      reportType: 'categoryWiseBookUsage',
      reportName: 'Category-wise Book Usage'
    },
    16: {
      reportType: 'requisitionHistory',
      reportName: 'Requisition History'
    },
    17: {
      reportType: 'donorList',
      reportName: 'Donor List'
    },
    18: {
      reportType: 'resourceTitle',
      reportName: 'Resource Title'
    },
    19: {
      reportType: 'specimenCopy',
      reportName: 'Specimen Copy'
    },
    20: {
      reportType: 'categoryWiseTitleWiseReport',
      reportName: 'Category Wise Title Wise Report'
    },

    21: {
      reportType: 'resourceTypeWiseTitleReport',
      reportName: 'Resource Type Wise Title Report'
    },
    22: {
      reportType: 'yearlyPurchaseOfPeriodicalsJournals',
      reportName: 'Yearly Purchase of Periodicals/Journals Report'
    },
    23: {
      reportType: 'libraryUtilizationStatisticalReport',
      reportName: 'Library Utilization Statistical Report'
    },
    24: {
      reportType: 'dayWiseLibraryEntries',
      reportName: 'Day wise library entries report'
    },
    25: {
      reportType: 'fineReport',
      reportName: 'Fine Report'
    },
    26: {
      reportType: 'seriesWiseTitle',
      reportName: 'Series Wise Title Report'
    },
    27: {
      reportType: 'departmentWiseTitleReport',
      reportName: 'Department Wise Title Report'
    },
    28: {
      reportType: 'periodicalsDailyReports',
      reportName: 'Periodicals Daily Reports'
    },
    29: {
      reportType: 'periodicalsMonthly',
      reportName: 'Periodicals/Journal Monthly Reports'
    },
    30: {
      reportType: 'issueReturnMailNotification',
      reportName: 'Issue/Return Mail Notification Report'
    },

    31: {
      reportType: 'studentSemesterWiseFine',
      reportName: 'Student Semester Wise Fine Report'
    },
    32: {
      reportType: 'accessionNumberWiseIssueReturnHistory',
      reportName: 'Accession Number Wise Issue/Return History Report'
    },
    33: {
      reportType: 'departmentWiseEresource',
      reportName: 'Department wise e-resource report'
    },
    34: {
      reportType: 'semesterWiseStudentFine',
      reportName: 'Semester Wise Student Fine Report'
    },
    35: {
      reportType: 'studentWiseLibraryStatistics',
      reportName: 'Student-Wise Library Statistics'
    },
    36: {
      reportType: 'periodicalReport',
      reportName: 'Periodical Report'
    },
    37: {
      reportType: 'scannedResourcesReport',
      reportName: 'Scanned Stock Resources Report'
    },
    38: {
      reportType: 'issuedResourcesReport',
      reportName: 'Issued Stock Resources Report'
    },
    39: {
      reportType: 'missingYetToScanResourcesReport',
      reportName: 'Missing/Yet to Scan Stock Resources Report'
    },
    40: {
      reportType: 'departmentWiseSummaryReport',
      reportName: 'Department-Wise Summary Report'
    },
    41: {
      reportType: 'facultyWiseLibraryStatistics',
      reportName: 'Faculty-Wise Library Statistics'
    },
    42: {
      reportType: 'receivedAndNonReceivedPeriodicalReport',
      reportName: 'Received and Non-Received Periodical Reports'
    },
    43: {
      reportType: 'libraryEntryReport',
      reportName: 'Library Entry Reports'
    },
    44: {
      reportType: 'userWiseIssuedReturnResourcesByAcadYear',
      reportName: 'Department / Group Wise Issue Return'
    },
  })

  useEffect(() => {
    if (props.match.params.id != "allReports") {

      if (
        document.getElementById("libraryHeader") &&
        document.getElementById("footer") &&
        document.getElementById("mySidenav")

      ) {
        document.getElementById("libraryHeader").style.display = "none";
        document.getElementById("footer").style.display = "none";
        document.getElementById("mySidenav").style.display = "none";
        document.getElementById("routeSetup").style.height = "88vh";
        if (document.getElementById("subcriptionStripId")) {
          document.getElementById('subcriptionStripId').style.display = 'none';
        }
      }
    }
  }, []);

  const returnReport = () => {
    if (props.match.params.id == 23) {
      return <UtilizationStatasticalReport />;
    }
    // else if(props.match.params.id == 1) {
    // 	return <MeetingListReport/>;
    // }else if(props.match.params.id == 2) {
    // 	return <CommitteeAndMeetingReport/>;
    // }else  if(props.match.params.id == 3) {
    // 	return <NoTypeOfMeetingConductedReport/>;
    // }else if(props.match.params.id == 4) {          
    // 	return <MomUploadReport/>;
    // }else if(props.match.params.id == 5) {
    // 	return <NotUploadedMOMReport/>;
    // }else if(props.match.params.id == 6) {
    // 	return <CommitteeMembersReport/>;
    // }else if(props.match.params.id == 7) {
    // 	return <IndividualCommitteeMeetingList/>;
    // }else if(props.match.params.id == 8) {
    // 	return <EmployeeWiseCommitteeCountReport/>;
    // }else if(props.match.params.id == 9) {
    // 	return <EmployeeCommitteeRoleAndResponsibility/>;
    // }else if(props.match.params.id == 10) {
    // 	return <IndividualEmployeeWiMeeAttReport />;
    // }else if(props.match.params.id == 11) {
    // 	return <IndividualMeetingSummary/>;
    // }else if(props.match.params.id == 12) {
    // 	return <IndividualCommitteeSummary/>;
    // }else if(props.match.params.id == 13) {
    // 	return <CommitteeAndMeetingDetailsReport/>;
    // }
  }

  const closeReportVisibility = () => {
    setReportVisibility(false)
  }

  const returnViewReport = () => {
    return (
      <div className={reportVisibility ? "modal fade show" : "modal fade"} id="modalContainer" >
        <div className="modal-dialog modal-dialog-centered report-dialog" style={{ marginTop: 0 }}>
          <div className="modal-content" style={{ height: '100vh', width: '100% !important' }}>
            <div className="modal-header" id="reportsModalHeader" style={{ backgroundColor: "#0465ac" }}>
              <h6 className="modal-title text-white" style={{position: "sticky", top: 0}}>{currentReportName}</h6>
              <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="lg" onClick={() => closeReportVisibility()} style={{ cursor: "pointer" }} />
            </div>
            <div style={{
                overflowY: "auto",
                flex: 1,
                maxHeight: "calc(100vh - 100px)"
              }}>
                
              {/* className="modal-body report-body" */}
              {
                currentReportType == 'resourceListAsPerAccessionNumber' ?
                  <ResourceListAsPerAccessionNumber />
                  // <iframe
                  //   src={`${config.RootUrl}/faculty/library/report/ResourceList/ResourceListAsPerAccessionSeries.php?isIframe=true`}
                  //   className="iframe col-md-12"
                  // >
                  // </iframe>
                  : currentReportType == 'issuedResourceReport' ?
                    <iframe
                      src={`${config.RootUrl}/faculty/library/report/IssueReturnRenewReport/issueReport.php?isIframe=true`}
                      className="iframe col-md-12"
                    >
                    </iframe>
                    : currentReportType == 'returnedResourceReport' ?
                      <iframe
                        src={`${config.RootUrl}/faculty/library/report/IssueReturnRenewReport/returnReport.php?isIframe=true`}
                        className="iframe col-md-12"
                      >
                      </iframe>
                      : currentReportType == 'pendingResources' ?
                        <iframe
                          src={`${config.RootUrl}/faculty/library/report/notReturnedBooks/notReturned.php?isIframe=true`}
                          className="iframe col-md-12"
                        >
                        </iframe>
                        : currentReportType == 'yearlyPurchaseTitleWithCost' ?
                          <YearlyPurchaseTitleWithCostReport />
                          // <iframe
                          //   src={`${config.RootUrl}/faculty/library/report/YearlyPurchaseTitlesWithCost/YearlyPurchaseTitlesWithCost.php?isIframe=true`}
                          //   className="iframe col-md-12"
                          // >
                          // </iframe>
                          : currentReportType == 'categoryWiseYearlyPurchaseWithCost' ?
                            <CategoryWiseYearlyPurchaseWithCost />
                            // <iframe
                            //   src={`${config.RootUrl}/faculty/library/report/categoryWiseYearlyPurchase/categoryWiseYearlyPurchase.php?isIframe=true`}
                            //   className="iframe col-md-12"
                            // >
                            // </iframe>
                            : currentReportType == 'listOfMissingResource' ?
                              <iframe
                                src={`${config.RootUrl}/faculty/library/report/ListofMssingResource/ListofMssingResource.php?isIframe=true`}
                                className="iframe col-md-12"
                              >
                              </iframe>
                              : currentReportType == 'listOfDiscardedResources' ?
                                <iframe
                                  src={`${config.RootUrl}/faculty/library/report/DiscardedResourceList/DiscardedResourceList.php?isIframe=true`}
                                  className="iframe col-md-12"
                                >
                                </iframe>
                                : currentReportType == 'listOfDonatedResources' ?
                                  <iframe
                                    src={`${config.RootUrl}/faculty/library/report/DonatedResourceList/DonatedResourceList.php?isIframe=true`}
                                    className="iframe col-md-12"
                                  >
                                  </iframe>
                                  : currentReportType == 'userWiseIssuedReturnResources' ?
                                    <UserWiseIssuedReturnResource />
                                    // <iframe
                                    //   src={`${config.RootUrl}/faculty/library/report/UserWiseIssueReturn/UserWiseIssueReturn.php?isIframe=true`}
                                    //   className="iframe col-md-12"
                                    // >
                                    // </iframe>

                                    : currentReportType == 'instructorWithMostIssued' ?
                                      <iframe
                                        src={`${config.RootUrl}/faculty/library/report/InstructorWithMostIssued/InstructorWithMostIssued.php?isIframe=true`}
                                        className="iframe col-md-12"
                                      >
                                      </iframe>
                                      : currentReportType == 'learnerWithMostIssued' ?
                                        <iframe
                                          src={`${config.RootUrl}/faculty/library/report/LearnerWithMostIssued/LearnerWithMostIssued.php?isIframe=true`}
                                          className="iframe col-md-12"
                                        >
                                        </iframe>
                                        : currentReportType == 'currentlyBooksAvailableInLibrary' ?
                                          <iframe
                                            src={`${config.RootUrl}/faculty/library/report/bookIn/bookIn.php?isIframe=true`}
                                            className="iframe col-md-12"
                                          >
                                          </iframe>
                                          : currentReportType == 'booksCurrentlyNotAvailableInLibrary' ?
                                            <iframe
                                              src={`${config.RootUrl}/faculty/library/report/bookOut/bookOut.php?isIframe=true`}
                                              className="iframe col-md-12"
                                            >
                                            </iframe>
                                            : currentReportType == 'categoryWiseBookUsage' ?
                                              <iframe
                                                src={`${config.RootUrl}/faculty/library/report/categoryWiseBookUsage/categoryWiseBookUsage.php?isIframe=true`}
                                                className="iframe col-md-12"
                                              >
                                              </iframe>
                                              : currentReportType == 'requisitionHistory' ?
                                                <iframe
                                                  src={`${config.RootUrl}/faculty/library/report/RequisitionHistory/RequisitionHistory.php?isIframe=true`}
                                                  className="iframe col-md-12"
                                                >
                                                </iframe>
                                                : currentReportType == 'donorList' ?
                                                  <DonorList />
                                                  // <iframe
                                                  //   src={`${config.RootUrl}/faculty/library/report/donorList/donorList.php?isIframe=true`}
                                                  //   className="iframe col-md-12"
                                                  // >
                                                  // </iframe>
                                                  : currentReportType == 'resourceTitle' ?
                                                    <ResourceTitleReport />
                                                    // <iframe
                                                    //   src={`${config.RootUrl}/faculty/library/report/resourceTitle/resourceTitle.php?isIframe=true`}
                                                    //   className="iframe col-md-12"
                                                    // >
                                                    // </iframe>
                                                    : currentReportType == 'specimenCopy' ?
                                                      <iframe
                                                        src={`${config.RootUrl}/faculty/library/report/specimenCopy/specimenCopy.php?isIframe=true`}
                                                        className="iframe col-md-12"
                                                      >
                                                      </iframe>
                                                      : currentReportType == 'categoryWiseTitleWiseReport' ?
                                                        <iframe
                                                          src={`${config.RootUrl}/faculty/library/report/ResourceCount/ResourceCount.php?isIframe=true`}
                                                          className="iframe col-md-12"
                                                        >
                                                        </iframe>

                                                        : currentReportType == 'resourceTypeWiseTitleReport' ?
                                                          <iframe
                                                            src={`${config.RootUrl}/faculty/library/report/ResourceType/ResourceType.php?isIframe=true`}
                                                            className="iframe col-md-12"
                                                          >
                                                          </iframe>
                                                          : currentReportType == 'yearlyPurchaseOfPeriodicalsJournals' ?
                                                            <iframe
                                                              src={`${config.RootUrl}/faculty/library/report/YearlyPurchaseOfPeriodicals/PeriodicalsYearlyPurchase.php?isIframe=true`}
                                                              className="iframe col-md-12"
                                                            >
                                                            </iframe>
                                                            : currentReportType == 'libraryUtilizationStatisticalReport' ?
                                                              <UtilizationStatasticalReport />
                                                              : currentReportType == 'dayWiseLibraryEntries' ?
                                                                <iframe
                                                                  src={`${config.RootUrl}/faculty/library/report/DayWiseLibraryEntries/DayWiseLibraryEntries.php?isIframe=true`}
                                                                  className="iframe col-md-12"
                                                                >
                                                                </iframe>
                                                                : currentReportType == 'fineReport' ?
                                                                  <FineReport />
                                                                  // <iframe
                                                                  //   src={`${config.RootUrl}/faculty/library/report/ReturnedCollectedFine/ReturnedCollectedFine.php?isIframe=true`}
                                                                  //   className="iframe col-md-12"
                                                                  // >
                                                                  // </iframe>
                                                                  : currentReportType == 'seriesWiseTitle' ?
                                                                    <iframe
                                                                      src={`${config.RootUrl}/faculty/library/report/SeriesWiseTitleReport/SeriesWiseTitleReport.php?isIframe=true`}
                                                                      className="iframe col-md-12"
                                                                    >
                                                                    </iframe>
                                                                    : currentReportType == 'departmentWiseTitleReport' ?
                                                                      <iframe
                                                                        src={`${config.RootUrl}/faculty/library/report/DepartmentWiseTitleReport/DepartmentWiseTitleReport.php?isIframe=true`}
                                                                        className="iframe col-md-12"
                                                                      >
                                                                      </iframe>
                                                                      : currentReportType == 'periodicalsDailyReports' ?
                                                                        <iframe
                                                                          src={`${config.RootUrl}/faculty/library/report/periodicalsDailyLogsReport/PeriodicalsDailyLogsReports.php?isIframe=true`}
                                                                          className="iframe col-md-12"
                                                                        >
                                                                        </iframe>
                                                                        : currentReportType == 'periodicalsMonthly' ?
                                                                          <iframe
                                                                            src={`${config.RootUrl}/faculty/library/report/journalReport/JournalReport.php?isIframe=true`}
                                                                            className="iframe col-md-12"
                                                                          >
                                                                          </iframe>
                                                                          : currentReportType == 'issueReturnMailNotification' ?
                                                                            <iframe
                                                                              src={`${config.RootUrl}/faculty/library/report/issueReturnMailNotificationHistory/issueReturnMailNotificationHistory.php?isIframe=true`}
                                                                              className="iframe col-md-12"
                                                                            >
                                                                            </iframe>

                                                                            : currentReportType == 'studentSemesterWiseFine' ?
                                                                              <iframe
                                                                                src={`${config.RootUrl}/faculty/library/report/StudentSemesterFineReport/StudentSemesterFineReport.php?isIframe=true`}
                                                                                className="iframe col-md-12"
                                                                              >
                                                                              </iframe>
                                                                              : currentReportType == 'accessionNumberWiseIssueReturnHistory' ?
                                                                                <iframe
                                                                                  src={`${config.RootUrl}/faculty/library/report/AccessionNumberWiseIssueOrReturnHistoryReport/AccessionNumberWiseIssueOrReturnHistoryReport.php?isIframe=true`}
                                                                                  className="iframe col-md-12"
                                                                                >
                                                                                </iframe>
                                                                                : currentReportType == 'departmentWiseEresource' ?
                                                                                  <iframe
                                                                                    src={`${config.RootUrl}/faculty/library/report/DepartmentWiseEresourceReprt/DepartmentWiseEresourceReprt.php?isIframe=true`}
                                                                                    className="iframe col-md-12"
                                                                                  >
                                                                                  </iframe> : currentReportType == 'semesterWiseStudentFine' ?
                                                                                    <iframe
                                                                                      src={`${config.RootUrl}/faculty/library/report/semesterWiseStudentFineReport/semesterWiseStudentFineReport.php?isIframe=true`}
                                                                                      className="iframe col-md-12"
                                                                                    >
                                                                                    </iframe> :
                                                                                    currentReportType == 'studentWiseLibraryStatistics' ?
                                                                                      <StudentWiseLibraryStatistics /> :
                                                                                      currentReportType == 'periodicalReport' ?
                                                                                        <PeriodicalReport /> : currentReportType == 'scannedResourcesReport' ?
                                                                                          <ScannedResourceReport /> : currentReportType == 'issuedResourcesReport' ?
                                                                                            <IssuedResourceReport /> : currentReportType == 'missingYetToScanResourcesReport' ?
                                                                                              <MissingYetToScanResourceReport /> : currentReportType == 'departmentWiseSummaryReport' ?
                                                                                                <DepartmentWiseSummaryReport /> : currentReportType == 'facultyWiseLibraryStatistics' ?
                                                                                                  <FacultyWiseLibraryStatistics /> : currentReportType == 'receivedAndNonReceivedPeriodicalReport' ?
                                                                                                  <ReceivedNonReceivedPeriodicalReport /> :  currentReportType == 'libraryEntryReport' ?
                                                                                                  <LibraryEntryReport /> : currentReportType == 'userWiseIssuedReturnResourcesByAcadYear' ?
                                                                                                  <UserWiseIssuedReturnResourceByAcdYear /> : ""
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (

    <>
      {
        props.match.params.id == "allReports" ?
          <>
            <RoutingMenu activeScreen="reports" />
            {/* <div className=''>

              <iframe
                src={`${config.RootUrl}/faculty/library/report/libraryReportHTML.php?isIframe=true`}
                className="iframe col-md-12"
              >
              </iframe>
            </div> */}

            <div className="libraryComponents-container">
              {/* report header */}
              <div className="row">
                <div className="col-md-6">
                  <h3 style={{ fontSize: '22px', fontWeight: '300' }}><b>Reports</b></h3>
                </div>

              </div>

              {/* search by report name  */}
              <div className="row align-items-center my-2" style={{ backgroundColor: "#f7f7fa", padding: "0.5rem" }}>
                <div class="col-md-3">
                  <div >
                    <input
                      type="text"
                      className="form-control formControlAutoTask"
                      name=""
                      placeholder="Enter report name"
                      value={searchFilterText}
                      onChange={e => setSearchFilterText(e.target.value)}
                      style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '7px' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <button class="btn" style={{ color: '#fff', fontSize: '14px', borderRadius: '7px', backgroundColor: '#0465AC' }} onClick={() => setSearchFilterText('')}>Clear</button>
                </div>
              </div>

              {/* category-wise sections */}
              <div className="row mt-1 mb-2 gy-2" >
                {/* Report Changes Div Start */}
                {/* category:1 start */}
                <div
                  className="row align-items-center my-2 mb-4"
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    display: (Object.values(reportDetails).filter((report, index) => (index + 1 == 1 || index + 1 == 7 || index + 1 == 8 || index + 1 == 9 || index + 1 == 16 || index + 1 == 20 || index + 1 == 21 || index + 1 == 26 || index + 1 == 27 || index + 1 == 5 || index + 1 == 6 || index + 1 == 23 || index + 1 == 18 || index + 1 == 13 || index + 1 == 33 || index + 1 == 37 || index + 1 == 38 || index + 1 == 39 || index + 1 == 40)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).length > 0) ? "" : "none"
                  }}
                >
                  <p>Resource List Reports</p>
                </div>
                <div className="d-flex grid_for_reports flex-wrap ">
                  {
                    !searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 1 || index + 1 == 7 || index + 1 == 8 || index + 1 == 9 || index + 1 == 16 || index + 1 == 20 || index + 1 == 21 || index + 1 == 26 || index + 1 == 27 || index + 1 == 5 || index + 1 == 6 || index + 1 == 23 || index + 1 == 18 || index + 1 == 13 || index + 1 == 33 || index + 1 == 37 || index + 1 == 38 || index + 1 == 39 || index + 1 == 40)).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }
                          }
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }

                  {
                    searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 1 || index + 1 == 7 || index + 1 == 8 || index + 1 == 9 || index + 1 == 16 || index + 1 == 20 || index + 1 == 21 || index + 1 == 26 || index + 1 == 27 || index + 1 == 5 || index + 1 == 6 || index + 1 == 23 || index + 1 == 18 || index + 1 == 13 || index + 1 == 33 || index + 1 == 37 || index + 1 == 38 || index + 1 == 39 || index + 1 == 40)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }}
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }
                </div>
                {/* category:1 end */}

                {/* category:2 start */}
                <div
                  className="row align-items-center mt-5 mb-4"
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    display: (Object.values(reportDetails).filter((report, index) => (index + 1 == 2 || index + 1 == 3 || index + 1 == 4 || index + 1 == 32 || index + 1 == 34 || index + 1 == 25 || index + 1 == 31 || index + 1 == 30 || index + 1 == 10 || index + 1 == 35 || index + 1 == 11 || index + 1 == 12 || index + 1 == 41 || index + 1 == 44)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).length > 0) ? "" : "none"
                  }}
                //
                >
                  <p>Issue Return Report</p>
                </div>
                <div className="d-flex grid_for_reports flex-wrap ">
                  {
                    !searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 2 || index + 1 == 3 || index + 1 == 4 || index + 1 == 32 || index + 1 == 34 || index + 1 == 25 || index + 1 == 31 || index + 1 == 30 || index + 1 == 10 || index + 1 == 35 || index + 1 == 11 || index + 1 == 12 || index + 1 == 41 || index + 1 == 44)).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }
                          }
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }

                  {
                    searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 2 || index + 1 == 3 || index + 1 == 4 || index + 1 == 32 || index + 1 == 34 || index + 1 == 25 || index + 1 == 31 || index + 1 == 30 || index + 1 == 10 || index + 1 == 35 || index + 1 == 11 || index + 1 == 12 || index + 1 == 41 || index + 1 == 44)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }}
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }
                </div>
                {/* category:2 end */}

                {/* category:3 start */}
                <div
                  className="row align-items-center mt-5 mb-4"
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    display: (Object.values(reportDetails).filter((report, index) => (index + 1 == 13 || index + 1 == 14 || index + 1 == 15)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).length > 0) ? "" : "none"
                  }}
                >
                  <p>Inventory Reports</p>
                </div>
                <div className="d-flex grid_for_reports flex-wrap ">
                  {
                    !searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 13 || index + 1 == 14 || index + 1 == 15)).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }
                          }
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }

                  {
                    searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 13 || index + 1 == 14 || index + 1 == 15)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }}
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }
                </div>
                {/* category:3 end */}

                {/* category:4 start */}
                <div
                  className="row align-items-center mt-5 mb-4"
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    display: (Object.values(reportDetails).filter((report, index) => (index + 1 == 17)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).length > 0) ? "" : "none"
                  }}
                >
                  <p>Donor Reports</p>
                </div>
                <div className="d-flex grid_for_reports flex-wrap ">
                  {
                    !searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 17)).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }
                          }
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }

                  {
                    searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 17)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }}
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }
                </div>
                {/* category:4 end */}

                {/* category:5 start */}
                <div
                  className="row align-items-center mt-5 mb-4"
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    display: (Object.values(reportDetails).filter((report, index) => (index + 1 == 22 || index + 1 == 28 || index + 1 == 29 || index + 1 == 36 || index + 1 == 42)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).length > 0) ? "" : "none"
                  }}
                >
                  <p>Periodicals & Journal Reports</p>
                </div>
                <div className="d-flex grid_for_reports flex-wrap ">
                  {
                    !searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 22 || index + 1 == 28 || index + 1 == 29 || index + 1 == 36 || index + 1 == 42)).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }
                          }
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }

                  {
                    searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 22 || index + 1 == 28 || index + 1 == 29 || index + 1 == 36 || index + 1 == 42)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }}
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }
                </div>
                {/* category:5 end */}

                {/* category:6 start */}
                <div
                  className="row align-items-center mt-5 mb-4"
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    display: (Object.values(reportDetails).filter((report, index) => (index + 1 == 24 || index + 1 == 43)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).length > 0) ? "" : "none"
                  }}
                >
                  <p>Library Entry</p>
                </div>
                <div className="d-flex grid_for_reports flex-wrap ">
                  {
                    !searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 24 || index + 1 == 43)).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }
                          }
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }

                  {
                    searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 24 || index + 1 == 43)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }}
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }
                </div>
                {/* category:6 end */}

                {/* category:7 start */}
                <div
                  className="row align-items-center mt-5 mb-4"
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    display: (Object.values(reportDetails).filter((report, index) => (index + 1 == 19)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).length > 0) ? "" : "none"
                  }}
                >
                  <p>Miscellaneous</p>
                </div>
                <div className="d-flex grid_for_reports flex-wrap ">
                  {
                    !searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 19)).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }
                          }
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }

                  {
                    searchFilterText &&
                    Object.values(reportDetails).filter((report, index) => (index + 1 == 19)).filter(report => report.reportName.toLowerCase().includes(searchFilterText.toLowerCase())).map(report => {
                      return (
                        <div className="d-flex align-items-center pl-4 card_Report nav-link"
                          onClick={(e) => {
                            setReportVisibility(true)
                            setCurrentReportName(report.reportName);
                            setCurrentReportType(report.reportType);
                            setSearchFilterText('')
                          }}
                        >
                          <FontAwesomeIcon className="qa-icon icon  mr-3" icon={['far', 'file-alt']} size="lg" />
                          {report.reportName}
                        </div>
                      )
                    })
                  }
                </div>
                {/* category:7 end */}
                {/* Report Changes Div End */}
              </div>
            </div>

            {
              returnViewReport()
            }
          </>
          :
          <>
            {
              returnReport()
            }
          </>
      }

    </>
  )
}
